/**
 * Price Per Day Component for Horizons Theme
 * Mimics the theme's native ProductPrice update logic.
 */
class PricePerDay extends HTMLElement {
  constructor() {
    super();
    this.updatePrice = this.updatePrice.bind(this);
  }

  connectedCallback() {
    // Horizons uses a constant, but in vanilla JS we listen for the string event name
    // Based on the theme file, the event string is likely 'variant:update'
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.addEventListener('variant:update', this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.removeEventListener('variant:update', this.updatePrice);
    }
  }

  updatePrice(event) {
    // 1. Security Check: Ensure we are updating the correct product
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // 2. Extract the new HTML for THIS block from the event payload
    // We look for the same custom element in the new HTML provided by Shopify
    const newContentSource = event.detail.data.html.querySelector(`price-per-day [ref="container"]`);
    const currentContentContainer = this.querySelector('[ref="container"]');

    if (!newContentSource || !currentContentContainer) {
      // If the new variant doesn't have a price per day, empty the current one
      if (currentContentContainer) currentContentContainer.innerHTML = '';
      return;
    }

    // 3. Update the DOM if content has changed
    if (currentContentContainer.innerHTML !== newContentSource.innerHTML) {
      currentContentContainer.innerHTML = newContentSource.innerHTML;
    }
  }
}

if (!customElements.get('price-per-day')) {
  customElements.define('price-per-day', PricePerDay);
}